import {
  Divider,
  Navbar,
  NavbarContent,
  NavbarMenu,
  NavbarMenuToggle,
} from '@heroui/react';
import { useState } from 'react';
import NavbarLinkItem from './components/NavbarItem';
import NavbarLogo from './components/NavbarLogo';
import NavbarMenuMobile from './components/NavbarMenuMobile';
import NavbarProfile from './components/NavbarProfile';
import { navbarLinks } from './utils/navbarLinks';

/**
 * Componente principal de navegación de la aplicación
 * Renderiza una barra de navegación responsiva con menú desktop, menú móvil y perfil de usuario
 * Utiliza HeroUI Navbar con gradiente personalizado y animaciones
 *
 * Características:
 * - Menú de navegación principal (desktop)
 * - Menú hamburguesa para móviles
 * - Logo institucional
 * - Dropdown de perfil de usuario
 */
const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <Navbar
      isMenuOpen={isMenuOpen}
      onMenuOpenChange={setIsMenuOpen}
      maxWidth="full"
      classNames={{
        base: [
          'bg-gradient-to-tl to-gradient-pink from-primary-pink',
          'rounded-xl',
          'h-16',
        ],
        menu: [
          'bg-gradient-to-tl to-gradient-pink from-primary-pink text-secondary-white font-semibold',
          'p-5 sm:ml-1 mt-6 mx-auto sm:w-[50%] w-[98%] rounded-xl overflow-hidden',
        ],
        menuItem: ['hover:scale-105 duration-300 origin-left'],
      }}
    >
      <NavbarContent className="md:hidden text-secondary-white" justify="start">
        <NavbarMenuToggle
          aria-label={isMenuOpen ? 'Cerrar menu' : 'Abrir menu'}
        />
        <NavbarLogo />
      </NavbarContent>

      <NavbarContent
        className="md:flex gap-8 w-full text-secondary-white font-semibold hidden"
        justify="center"
      >
        <NavbarLogo />
        {navbarLinks.map((item) => (
          <NavbarLinkItem key={item.key} item={item} />
        ))}
      </NavbarContent>

      <Divider
        orientation="vertical"
        className="hidden md:flex w-[.10rem] h-12 bg-secondary-white opacity-80"
      />

      <NavbarContent as="div" justify="end">
        <NavbarProfile />
      </NavbarContent>

      <NavbarMenu>
        {navbarLinks.map((item) => (
          <NavbarMenuMobile key={item.key} item={item} onClick={toggleMenu} />
        ))}
      </NavbarMenu>
    </Navbar>
  );
};

export default NavBar;
